module.exports = __webpack_public_path__ + "img/multipleFiles.837010a3.svg";